import React, { Component } from "react"
import styled, { injectGlobal, css } from 'styled-components'
import Link from "gatsby-link"
import { find } from 'lodash'
import { rgba } from 'polished'

import { Block, Share, MetaTags, ScrollProgress, Footer, Section } from '../components'

import arrowBack from '../assets/icons/arrow-back.svg'

import { warmBrown } from '../styles/themes'
import { container, padding, bgImage, button, bgIcon, innerContainer, hoverState } from '../styles/global'
import { heading2, paragraph, caption, projectIntro } from '../styles/type'
import { media, isClient } from '../styles/utils'
import { grey } from '../styles/colors'

class Project extends Component {

	state = {
		data: []
	}
		
	componentWillMount = () => {
		const data = this.props.previewData || this.props.pathContext
		
		this.setState({
			data: data,
		})
	}

    renderSections = () => {
        const { data } = this.state;
        
        if (data.acf.sections) {
            return data.acf.sections.map((section, i) => {
                const blocks = section.blocks;

                if (section.display_section && section.blocks) {
                    return (
                        <Section
                            key={i}
                            blocks={blocks}
                            section={section}
                        />
                    )
                }
            })
        }
    }
    
    renderCredits = () => {

        const { data } = this.state;
        
        if(data.acf.credits){
            const credits = data.acf.credits.map((credit, i) => {
                return (
                    <Credit
                        key={i}
                    >
                        <Name>{credit.title}</Name>
                        <Val>{credit.value}</Val>
                    </Credit>
                ) 
            })
            return (
                <Credits>{credits}</Credits>
            )
        }
    }
    
    
  	render() {
        const { data } = this.state;

        if (data) {
            return (
                <React.Fragment>
                    <ScrollProgress/>

                    <Wrapper>

                        <MetaTags 
                            title={`Paul Conrad Architects — Project : ${data.title}`}
                            description={data.meta_description ? data.meta_description : ''}
                        />
                
                        <HeroImage
                            image={data.acf.hero_image.sizes.full_width}
                        />

                        <Opening>
                            <Left>
                                <Title>{data.title}</Title>
                                <Meta>
                                    {data.acf.location && (
                                        <Name>{data.acf.location}</Name>
                                    )}
                                    { data.acf.dates && (
                                        <Name>{data.acf.dates}</Name>
                                    )}
                                    {this.renderCredits()}
                                </Meta>
                            </Left>
                            
                            <Right>
                                {data.acf.short_description && (
                                    <Description
                                        dangerouslySetInnerHTML={{__html: data.acf.short_description}}  
                                    />
                                )}
                            </Right>

                        </Opening>
                    
                        
                        {this.renderSections()}

                        <ContactPrompt>
                            <ContactPromptInner>
                                <PromptHeading>Work With Us</PromptHeading>
                                <PromptBody>
                                    <PromptCopy>
                                        For project enquiries and further information, contact the studio.
                                    </PromptCopy>
                                    <PromptButton to={'/contact'}>Get in touch</PromptButton>
                                </PromptBody>
                            </ContactPromptInner>
                        </ContactPrompt>

                        <Footer
                            title={data.title}
                            pageURL={isClient() ? window.location.href : '' }
                            backLink={'/projects'}
                            backLinkText={'All Projects'}
                        />

                    </Wrapper>
                </React.Fragment>
            )	
        }
  	}
}



const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	z-index: 2;
    overflow-x: hidden;
    padding-top: 10rem;

    ${media.phone`
        padding-top: 0;
    `}
`

// Hero

const HeroImage = styled.div`
    width: 100%;
    height: 600px;
    margin-bottom: 10rem;
	background-image: url(${props => props.image});
	${bgImage}

    ${media.laptop`
        height: 500px;
    `}

    ${media.tablet`
        height: 400px;
    `}

    ${media.phone`
        height: 235px;
    `}
`


//// project opening


// layout

const Left = styled.div``
const Right = styled.div``
const Opening = styled.div`
    ${innerContainer};
    display: flex;
    flex-direction: row;
    margin-bottom: 15rem;

    ${media.tablet`
        flex-direction: column;
        align-items: center;
    `}

    ${Left}, ${Right} {
		flex: 50%;
		box-sizing: border-box;

        ${media.tablet`
            flex: none;
            width: 360px;
            max-width: 100%;
        `}
    }

    ${Left} {
        padding-right: 2.5rem; /* half gutter size */

        ${media.tablet`
            padding-right: 0;
        `}
    }

    ${Right} {
        padding-left: 2.5rem; /* half gutter size */

        ${media.tablet`
            padding-left: 0;
        `}
    }
`


// type styles

const Title = styled.div`
    margin-bottom: 2rem;
    font-family: 'Scto';
    font-weight: 300;
    font-size: 34px;
    line-height: 40px;
    letter-spacing: -0.5px;

    ${media.laptop`
        font-size: 25.5px;
        line-height: 1;
        letter-spacing: -0.4px;
    `}
`

const Name = styled.div``
const Credit = styled.div``
const Val = styled.div`` 
const Credits = styled.div``

const Meta = styled.div`
    * {
        ${caption};
        text-indent: 0!important;
    }

    > ${Credits} > ${Credit} {
        margin-top: 1rem;

        > ${Name} {
            font-weight: 400;
        }
    }
`

const Description = styled.div`
    ${media.tablet`
        margin-top: 4rem;
    `}

    &, > * {
        ${paragraph};
    }
`


// End-of-page contact prompt (ticket #5)
const ContactPromptInner = styled.div`
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8rem 2.5rem;
    box-sizing: border-box;

    ${media.laptop`
        padding: 6rem 2.5rem;
    `}

    ${media.tablet`
        flex-direction: column;
        padding: 6rem 40px;
    `}
`

const PromptHeading = styled.div`
    flex: 0 0 50%;
    padding-right: 6rem;
    box-sizing: border-box;
    font-family: 'Scto';
    font-weight: 300;
    font-size: 30px;
    line-height: 36px;
    color: ${grey};

    ${media.laptop`
        font-size: 22px;
        line-height: 28px;
    `}

    /* Stack layout on mobile — take only content height, not 50% of container. */
    ${media.tablet`
        flex: 0 0 auto;
        padding-right: 0;
        margin-bottom: 3rem;
    `}
`

const PromptBody = styled.div`
    flex: 0 0 50%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    box-sizing: border-box;

    ${media.tablet`
        flex: 0 0 auto;
    `}
`

const PromptCopy = styled.div`
    ${paragraph};
    color: ${grey};
    margin-bottom: 2.5rem;
    max-width: 400px;
`

const PromptButton = styled(Link)`
    display: inline-block;
    background: #F5F4F2;
    color: ${grey};
    font-size: 16px;
    line-height: 1;
    padding: 14px 22px;
    ${hoverState};

    ${media.laptop`
        font-size: 14px;
    `}
`

const ContactPrompt = styled.div`
    width: 100%;
    /* Inherits the page colour so the end of a project page reads as one
       continuous tone instead of a separate block. */
    background: transparent;
    display: flex;
    justify-content: center;
    margin-top: 10rem;
`


export default Project





// WEBPACK FOOTER //
// ./src/templates/project.js